"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _ValidationTooltip = _interopRequireDefault(require("../Tooltip/_ValidationTooltip"));
var _messages = require("../utils/messages");
var _console = _interopRequireDefault(require("../utils/console"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _StyleConfig = require("../utils/StyleConfig");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _CheckboxConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-concur_android.css") : void 0);
var _CheckboxConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-concur_default.css") : void 0);
var _CheckboxConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-concur_gateway.css") : void 0);
var _CheckboxConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-concur_ios.css") : void 0);
var _CheckboxSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_fiori_3_dark.css") : void 0);
var _CheckboxSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_fiori_3_hcb.css") : void 0);
var _CheckboxSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_fiori_3_hcw.css") : void 0);
var _CheckboxSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_fiori_3.css") : void 0);
var _CheckboxSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_horizon_dark.css") : void 0);
var _CheckboxSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_horizon_hcb.css") : void 0);
var _CheckboxSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_horizon_hcw.css") : void 0);
var _CheckboxSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox-sap_horizon.css") : void 0);
var _excluded = ["checked", "className", "classNameMap", "disabled", "hiddenLabel", "indeterminate", "inline", "inputProps", "label", "labelProps", "onChange", "required", "size", "validationMessage", "inputRef", "isControlled"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _CheckboxConcur_android.default,
  concur_default: _CheckboxConcur_default.default,
  concur_gateway: _CheckboxConcur_gateway.default,
  concur_ios: _CheckboxConcur_ios.default,
  sap_fiori_3_dark: _CheckboxSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _CheckboxSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _CheckboxSap_fiori_3_hcw.default,
  sap_fiori_3: _CheckboxSap_fiori_.default,
  sap_horizon_dark: _CheckboxSap_horizon_dark.default,
  sap_horizon_hcb: _CheckboxSap_horizon_hcb.default,
  sap_horizon_hcw: _CheckboxSap_horizon_hcw.default,
  sap_horizon: _CheckboxSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-checkbox';

/** **Checkbox** is a specialized form control that emits an
 * `<input>` with a type of checkbox. */

var Checkbox = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _classnames;
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Checkbox, _props)) : _props;
  var checked = props.checked,
    className = props.className,
    classNameMap = props.classNameMap,
    disabled = props.disabled,
    hiddenLabel = props.hiddenLabel,
    indeterminate = props.indeterminate,
    inline = props.inline,
    inputProps = props.inputProps,
    label = props.label,
    labelProps = props.labelProps,
    _onChange = props.onChange,
    required = props.required,
    size = props.size,
    validationMessage = props.validationMessage,
    inputRef = props.inputRef,
    isControlled = props.isControlled,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var localInputRef = (0, _react.useRef)();
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(_StyleConfig.CSS_PREFIX, CSS_BLOCK, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--").concat(size), size === 'md'), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--disabled"), disabled), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--inline"), inline), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--").concat(validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state), !!validationMessage), _classnames));
  var inputClasses = classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__input"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__input--indeterminate"), indeterminate), inputProps === null || inputProps === void 0 ? void 0 : inputProps.className);
  (0, _useUniversalLayoutEffect.default)(function () {
    if (!localInputRef.current) {
      return;
    }
    if (indeterminate) {
      localInputRef.current.indeterminate = true;
    } else {
      localInputRef.current.indeterminate = false;
    }
  });
  var ariaLabel;
  if (!hiddenLabel && validationMessage !== null && validationMessage !== void 0 && validationMessage.text) {
    var _context;
    ariaLabel = (0, _concat.default)(_context = "".concat(label, " ")).call(_context, validationMessage.text);
  }
  if (hiddenLabel && required) {
    _console.default.warn(_messages.ELEMENT_VALIDATION_WARNINGS.CHECKBOX_HIDDEN_LABEL_REQUIRED);
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _react.default.createElement("label", (0, _extends2.default)({}, otherProps, labelProps, {
      className: classes,
      ref: ref
    }), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, inputProps, {
      "aria-label": ariaLabel,
      checked: isControlled ? !!checked : checked,
      className: inputClasses,
      disabled: disabled,
      onChange: function onChange(e) {
        _onChange(!checked, e);
      },
      ref: (0, _reactMergeRefs.default)([localInputRef, inputRef]),
      required: required,
      type: "checkbox"
    })), (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) && (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state) && /*#__PURE__*/_react.default.createElement(_ValidationTooltip.default, {
      size: size,
      state: validationMessage.state,
      text: validationMessage.text
    }), hiddenLabel ? /*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "--screen-reader-only"))
    }, label, ' ', validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) : /*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__label"))
    }, label), !disabled && required && /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true",
      className: classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__required"))
    }, "*"))
  );
});
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  /** Text label or a React node for **Checkbox** input.  */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  /** @ignore */
  isControlled: _propTypes.default.bool,
  /** When `true`, the **Checkbox** renders as `checked`. */
  checked: _propTypes.default.bool,
  /** Any custom classes to add to the `<label>` element. */
  className: _propTypes.default.string,
  /** When `true`, the **Checkbox** gets the `disabled` attribute. */
  disabled: _propTypes.default.bool,
  /** When `true`, the label will not be shown. It will still be present with a
   * `screen-reader-only` class which allows it to be read to assistive technologies. */
  hiddenLabel: _propTypes.default.bool,
  /** When `true`, the **Checkbox** renders a "mixed" state
   * (shows as a "-" in the **Checkbox**). */
  indeterminate: _propTypes.default.bool,
  /** When `true`, **Checkbox** components will be shown on the same row rather than stacked. */
  inline: _propTypes.default.bool,
  /** Attaches a ref to the `<input>` element. */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Other props to be spread onto the `<input>` tag. */
  inputProps: _propTypes.default.object,
  /** Other props to be spread onto the `<label>` tag. */
  labelProps: _propTypes.default.object,
  /** Adds the `required` attribute to the `<input>` element.
   *
   * NOTE: This does not perform any validation, but rather just marks the field as required. */
  required: _propTypes.default.bool,
  /** Size of the `<label>` element. Options are `'lg'` and `'md'`. */
  size: _propTypes.default.oneOf(_StyleConfig.CONTROL_SIZES),
  /** An object identifying a validation message.
   * The object will include properties for `state` and `text`;
   * _e.g._, `{ state: 'warning', text: 'This is your last warning' }`.
   *
   * The options for `state` are `'error'` and `'warning'`.
   *
   * `text` is the message shown in the validation tooltip;
   * as with all text, it must be localized. */
  validationMessage: _propTypes.default.shape({
    state: _propTypes.default.oneOf(_StyleConfig.FORM_CONTROL_VALIDATION_STATES).isRequired,
    text: _propTypes.default.string.isRequired
  }),
  /** Callback function for onChange events.
   * @param {boolean} checked
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   */
  onChange: _propTypes.default.func
};
Checkbox.defaultProps = {
  size: 'lg',
  onChange: function onChange() {}
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(Checkbox);
exports.default = _default;